import { render } from "./patentRatioChart.vue?vue&type=template&id=ea22bb9c"
import script from "./patentRatioChart.vue?vue&type=script&lang=js"
export * from "./patentRatioChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__